import { Language } from "./language.model";
import { Person } from "./person.model";
import { UserType } from "./user-type.model";
import { VerificationCenter } from "./verification-center.model";

export class User {

    id?: number;
    active?: boolean;

    account?: string;
    language?: Language;
    languageId?: number;
    password?: string;

    profiles?: Array<string>;
    verificationCenters?: Array<string>;
    verificationCentersData?: Array<VerificationCenter>;
    person?: Person;
    personId?: number;
    resetPassword?: boolean;
    userType?: UserType;
    userTypeId?: number;
    maskUser?: string;
    maskUserId?: number;
    imageData?: string;
    imageName?: string;

    //Propiedades extras
    isAssigned?: boolean;
    maskedUser?: User;
    currentUser?: User;

    constructor(source: Partial<User>) {
        Object.assign(this, source);
    }
}
